










import { Component, Vue } from "vue-property-decorator";
import ProposalForm from "@/components/sale/forms/ProposalForm.vue";

@Component({
  components: { ProposalForm },
})
export default class extends Vue {}
